var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('HeaderDefault',{class:{'webview-avaliable': _vm.hideHeader}}),_vm._v(" "),_c('div',{staticClass:"app-content container-xl app-container app"},[_c('div',{class:{'hidde-all': !_vm.loadingStatus}},[_c('Loading')],1),_vm._v(" "),_c('div',{staticClass:"conteudo-app",class:{'hidde-all': _vm.loadingStatus}},[_c('router-view')],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6777bcda","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 